export default {
  index: [
    {
      path: '/department',
      component: resolve => require(['./departmentIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/department/_router.js